import React from 'react';
import PropTypes from 'prop-types';

const GroupedJobProfiles = ({ jobProfiles }) => {
  if (!jobProfiles) {
    return null;
  }

  let groups = [];

  Object.keys(jobProfiles).forEach((item) => {
    groups.push({
      name: item,
      count: jobProfiles[item],
    });
  });

  groups = groups.sort((a, b) => {
    const nameA = a.name.toUpperCase(); // ignore upper and lowercase
    const nameB = b.name.toUpperCase(); // ignore upper and lowercase

    if (nameA < nameB) {
      return -1;
    }

    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const groupsMarkup = groups.map((group) => (
    <li className="list-group-item" key={group.name}>
      <span className="badge">
        <b>{group.count}</b>
      </span>{' '}
      <span className="list-item-label">{group.name}</span>
    </li>
  ));

  return <ul className="list-group">{groupsMarkup}</ul>;
};

GroupedJobProfiles.propTypes = {
  jobProfiles: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default GroupedJobProfiles;
